import { useStyles } from '@archipro-design/aria';
import { Outlet } from 'react-router';
import { data as routerData } from 'react-router';
import type { LoaderFunctionArgs } from '~/types/route-args';

import * as S from '@modules/professional/component/page-layout/PageLayout.style';
import { loader as infoLoader } from '@modules/professional/api/info-page-loader.server';
import { useShowProfessionalRevamp } from '@modules/professional/hook/use-professional-layout-data';
import { isProfessionalRevampActive } from '@modules/professional/util/is-professional-revamp-active.server';
import { shouldRevalidateProfessionalInfoLayout } from '~/modules/professional/util/professional-layout-revalidation';
import type { APHandle } from '~/modules/root';

export const handle: APHandle = {
    showBannerAndLogoMobile: true,
    hideContactArchiPro: true,
};

export const loader = async (args: LoaderFunctionArgs) => {
    // The revamp About page renders full-bleed at the index route, so skip the
    // heavy legacy info fetch here when the revamp is active.
    if (isProfessionalRevampActive(args.context, args.request)) {
        return routerData(null);
    }
    return infoLoader(args);
};

export const shouldRevalidate = shouldRevalidateProfessionalInfoLayout;

const ProfessionalInfoLayout = () => {
    const { css } = useStyles();
    // Through the shared hook, so this layout resolves the flag under the
    // Business Manager preview too. Naming the public route id left the
    // preview on the legacy container, which boxed the full-bleed revamp
    // into the old narrow gutters.
    const showRevamp = useShowProfessionalRevamp();

    // Revamp pages are full-bleed; drop the legacy container + gutters.
    if (showRevamp) return <Outlet />;

    return (
        <div className={css(S.PageContent)}>
            <div className={css(S.Container)}>
                <Outlet />
            </div>
        </div>
    );
};

export default ProfessionalInfoLayout;
